export const pollutant_map_columns = [
  {
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "idx" },
    align: "center"
  },
  {
    title: "站点名称",
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "河道",
    dataIndex: "river",
    key: "river"
  },
  {
    title: "街道",
    dataIndex: "street",
    key: "street"
  },
  {
    title: "污染类别",
    key: "category",
    dataIndex: "category"
  },
  {
    title: "一类污染源",
    key: "first_category",
    dataIndex: "first_category"
  },
  {
    title: "整改",
    key: "is_reform",
    dataIndex: "is_reform",
    scopedSlots: { customRender: "is_reform" }
  },
  {
    title: "核实",
    key: "is_check",
    dataIndex: "is_check",
    scopedSlots: { customRender: "is_check" }
  }
];

export const pollutant_columns = [
  {
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "idx" },
    align: "center"
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
    align: "center"
  },
  {
    title: "所属河道",
    dataIndex: "river",
    key: "river",
    align: "center"
  },
  {
    title: "所属街道",
    dataIndex: "street",
    key: "street",
    align: "center"
  },
  {
    title: "发现时间",
    dataIndex: "time",
    key: "time",
    align: "center"
  },
  {
    title: "污染类别",
    dataIndex: "category",
    key: "category",
    align: "center"
  },
  {
    title: "一类污染源",
    dataIndex: "first_category",
    key: "first_category",
    align: "center"
  },
  {
    title: "二类污染源",
    dataIndex: "second_category",
    key: "second_category",
    align: "center"
  },
  {
    title: "发生位置",
    dataIndex: "location",
    key: "location",
    align: "center"
  },
  {
    title: "是否核实",
    dataIndex: "is_check",
    key: "is_check",
    scopedSlots: { customRender: "is_check" },
    align: "center"
  },
  {
    title: "是否整改",
    dataIndex: "is_reform",
    key: "is_reform",
    scopedSlots: { customRender: "is_reform" },
    align: "center"
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center"
  }
];

export const alarm_list_columns = [
  {
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "idx" },
    align: "center"
  },
  {
    title: "站点名称",
    dataIndex: "station_name",
    key: "station_name",
    align: "center"
  },
  {
    title: "数据时间",
    dataIndex: "update_log_time",
    key: "update_log_time",
    align: "center",
    scopedSlots: { customRender: "update_log_time" }
  },
  {
    title: "开始时间",
    dataIndex: "start_log_time",
    key: "start_log_time",
    align: "center",
    scopedSlots: { customRender: "start_log_time" }
  },
  {
    title: "结束时间",
    dataIndex: "end_log_time",
    key: "end_log_time",
    align: "center",
    scopedSlots: { customRender: "end_log_time" }
  },
  {
    title: "持续时长",
    dataIndex: "duration",
    key: "duration",
    align: "center",
    scopedSlots: { customRender: "duration" }
  },
  {
    title: "报警类型",
    dataIndex: "type",
    key: "type",
    align: "center",
    scopedSlots: { customRender: "type" }
  },
  {
    title: "报警值",
    dataIndex: "value",
    key: "value",
    align: "center"
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center"
  }
];

export const alarm_rule_columns = [
  {
    key: "index",
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "index" },
    align: "center",
    width: 80
  },
  {
    title: "站点名称",
    dataIndex: "station_name",
    key: "station_name",
    align: "center",
    width: 100
  },
  {
    title: "监测类型",
    dataIndex: "param",
    scopedSlots: { customRender: "param" },
    key: "param",
    align: "center",
    width: 100
  },
  {
    title: "最小阈值",
    dataIndex: "min_threshold",
    key: "min_threshold",
    align: "center",
    width: 120
  },
  {
    title: "最大阈值",
    dataIndex: "max_threshold",
    key: "max_threshold",
    align: "center",
    width: 80
  },
  {
    title: "时间间隔",
    dataIndex: "td",
    key: "td",
    align: "center",
    width: 140
  },
  {
    title: "发送报警",
    dataIndex: "send_alarm",
    scopedSlots: { customRender: "send_alarm" },
    key: "send_alarm",
    align: "center",
    width: 140
  },
  {
    key: "operation",
    title: "操作",
    scopedSlots: { customRender: "operation" },
    width: 200,
    align: "center"
  }
];

export const online_rate_columns = [
  {
    title: "站点名称",
    dataIndex: "name",
    key: "name",
    align: "center"
  },
  {
    title: "在线小时",
    dataIndex: "hours",
    key: "hours",
    align: "center"
  },
  {
    title: "在线率",
    dataIndex: "online_rate",
    key: "online_rate",
    scopedSlots: { customRender: "online_rate" },
    align: "center"
  }
];

export const task_list_columns = [
  {
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "idx" },
    align: "center"
  },
  {
    title: "站点名称",
    dataIndex: "station_name",
    key: "station_name",
    align: "center"
  },
  {
    title: "任务类型",
    dataIndex: "task_type_name",
    key: "task_type_name",
    align: "center"
  },
  {
    title: "创建时间",
    dataIndex: "created_at",
    key: "created_at",
    align: "center"
  },
  {
    title: "运维人员",
    dataIndex: "ops_user",
    key: "ops_user",
    align: "center",
    scopedSlots: { customRender: "ops_user" }
  },
  {
    title: "任务状态",
    dataIndex: "task_status",
    scopedSlots: { customRender: "task_status" },
    key: "task_status",
    align: "center"
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center"
  }
];

export const pepole_list_columns = [
  {
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "idx" },
    align: "center"
  },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
    align: "center"
  },
  {
    title: "手机号",
    dataIndex: "phone",
    key: "phone",
    align: "center"
  },
  {
    title: "创建时间",
    dataIndex: "created_at",
    key: "created_at",
    scopedSlots: { customRender: "created_at" },
    align: "center"
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center"
  }
];

export const patrol_record_columns = [
  {
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "idx" },
    align: "center",
    width: 50
  },
  // {
  //   title: "设备",
  //   dataIndex: "device",
  //   key: "device",
  //   align: "center"
  // },
  {
    title: "巡查日期",
    dataIndex: "time",
    key: "time",
    scopedSlots: { customRender: "time" },
    align: "center",
    ellipsis: true,
    width: 90
  },
  {
    title: "任务",
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
    align: "center",
    ellipsis: true
  },
  {
    title: "路线",
    dataIndex: "road_name",
    key: "road_name",
    align: "center",
    ellipsis: true,
    width: 100
  },
  {
    title: "状态",
    dataIndex: "task_status",
    key: "task_status",
    scopedSlots: { customRender: "task_status" },
    align: "center",
    width: 80
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center",
    width: 240
  }
];

export const patrol_route_columns = [
  {
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "idx" },
    align: "center"
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    align: "center"
  },
  {
    title: "创建时间",
    dataIndex: "created_at",
    key: "created_at",
    align: "center"
  },
  // {
  //   title: "关联图片数",
  //   dataIndex: "img_num",
  //   key: "img_num",
  //   align: "center"
  // },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center"
  }
];

export const device_edit_project_columns = [
  {
    title: "序号",
    dataIndex: "index",
    scopedSlots: { customRender: "index" },
    align: "center"
  },
  {
    title: "id",
    dataIndex: "id",
    key: "id",
    align: "center"
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    align: "center"
  },
  {
    title: "sn",
    dataIndex: "sn",
    key: "sn",
    align: "center"
  },
  {
    title: "经度",
    dataIndex: "lng",
    key: "lng",
    align: "center"
  },
  {
    title: "纬度",
    dataIndex: "lat",
    key: "lat",
    align: "center"
  },
  {
    title: "河道",
    dataIndex: "river",
    key: "river",
    align: "center"
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center"
  }
];
